export const checkNested = (obj, level, ...rest) => {
  if (obj === undefined) return false
  if (rest.length === 0 && Object.prototype.hasOwnProperty.call(obj, level)) return true
  return checkNested(obj[level], ...rest)
}
// Example
// {level1:{level2:{level3:'level3'}} };

// checkNested(test, 'level1', 'level2', 'level3') // true
// checkNested(test, 'level1', 'level2', 'foo') // false

export function randomId() {
  return (
    '_' +
    (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(
      36
    )
  )
}
